import { useState } from 'react';
import { sendMagicCode, verifyMagicCode } from '../db/auth';

export function LoginPanel() {
  const [step, setStep] = useState<'email' | 'code'>('email');
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submitEmail(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      const lower = email.trim().toLowerCase();
      await sendMagicCode(lower);
      setEmail(lower);
      setStep('code');
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  }

  async function submitCode(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await verifyMagicCode(email, code.trim());
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="uin-form">
      <h3>Sign in</h3>
      <p className="uin-muted">A 6-digit code will be sent to your email.</p>

      {error && <div className="uin-error">{error}</div>}

      {step === 'email' ? (
        <form onSubmit={submitEmail}>
          <label className="uin-label">Email</label>
          <input
            type="email"
            required
            autoFocus
            className="uin-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
          />
          <button className="uin-btn-primary" type="submit" disabled={busy || !email}>
            {busy ? 'Sending…' : 'Send code'}
          </button>
        </form>
      ) : (
        <form onSubmit={submitCode}>
          <label className="uin-label">Code sent to {email}</label>
          <input
            type="text"
            required
            autoFocus
            className="uin-input"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="123456"
            inputMode="numeric"
            maxLength={6}
          />
          <button className="uin-btn-primary" type="submit" disabled={busy || code.length < 4}>
            {busy ? 'Verifying…' : 'Verify'}
          </button>
          <button
            type="button"
            className="uin-btn-link"
            onClick={() => {
              setStep('email');
              setCode('');
              setError(null);
            }}
          >
            Use a different email
          </button>
        </form>
      )}
    </div>
  );
}
